import { Directive, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appDateFormat]'
})
export class DateFormatDirective  {

  constructor( private ngControl: NgControl ) { }
  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    const numericValue = value.replace(/\D/g, '');
    let formattedValue = '';
    for(let i = 0; i < numericValue.length; i++) {
      if(i === 2 || i === 4) {
        formattedValue += '/';
      }
      formattedValue += numericValue.charAt(i);

    }
    this.ngControl.control?.setValue(formattedValue, { emitEvent: false })
  }


}

